import { DISPOSE_STORE as DISPOSE_ACTION_TYPE } from './constants';

export { disposableEpic } from './controllers/disposable-epic';
export { makeDisposable } from './controllers/disposable-store';

export const DISPOSE_ACTION = { type: DISPOSE_ACTION_TYPE } as const;
